/* global mixpanel */

import { environment } from 'js/config'
import createAdapter from './createAdapter'
import { getItem } from 'js/storeManager'

const mixpanelAdapter = createAdapter(
  () => {
    if (typeof mixpanel === 'undefined') return
    if (environment !== 'production' && !getItem('mixpanel')) return
    return window.mixpanel && window.mixpanel.__loaded
  },
  {
    alias(userId) {
      if (userId) mixpanel.alias(userId)
    },
    people(userId, userProperties, options) {
      if (userId) mixpanel.identify(userId)

      if (userProperties) {
        if (options && options.setOnce) {
          // Set people properties on our identified user, but only if they have not yet been set.
          mixpanel.people.set_once(userProperties)
        } else {
          // Set people properties on our identified user
          mixpanel.people.set(userProperties)
        }
      }
    },
    track(eventName, eventProperties) {
      if (eventName) mixpanel.track(eventName, eventProperties)
    },
    register(superProperties) {
      mixpanel.register(superProperties)
    },
    reset() {
      mixpanel.reset()
    },
  }
)

export { mixpanelAdapter as mixpanel }
